// ─── Contexte de langue (Core) ────────────────────────────────────
// Fournit t() à toute l'app. Langue = profil utilisateur (users/{uid}.langue),
// défaut « fr ». Surcharges admin (collection Firestore i18n) fusionnées en direct.
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { doc, setDoc, collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../auth/AuthContext';
import { LANGUE_DEFAUT, LANGUES, traduire } from './i18n';

const LangueContext = createContext(null);
export const useLangue = () => useContext(LangueContext) || { langue: LANGUE_DEFAUT, t: (k) => k, changerLangue: () => {}, LANGUES };
export const useT = () => useLangue().t;

export function LangueProvider({ children, langueParDefaut = LANGUE_DEFAUT }) {
  const { user } = useAuth();
  const [langue, setLangue]       = useState(langueParDefaut);
  const [overrides, setOverrides] = useState({});

  useEffect(() => {
    if (user?.langue && LANGUES.some(l => l.code === user.langue)) setLangue(user.langue);
    else setLangue(langueParDefaut);
  }, [user?.langue, langueParDefaut]);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, 'i18n'),
      snap => { const m = {}; snap.forEach(d => { m[d.id] = d.data() || {}; }); setOverrides(m); },
      () => {},
    );
    return () => unsub();
  }, []);

  const t = useCallback((key, params) => traduire(key, langue, overrides, params), [langue, overrides]);

  const changerLangue = useCallback(async (code) => {
    if (!LANGUES.some(l => l.code === code)) return;
    setLangue(code);
    if (user?.uid) { try { await setDoc(doc(db, 'users', user.uid), { langue: code }, { merge: true }); } catch {} }
  }, [user?.uid]);

  return (
    <LangueContext.Provider value={{ langue, t, changerLangue, LANGUES }}>
      {children}
    </LangueContext.Provider>
  );
}
